/**
 * Переключатель DS (canon-session 2026-07-24): трек, checked = accent +
 * сдвиг ручки вправо.
 */
export function Switch({
  checked = false,
  onChange,
  disabled = false,
  label,
}: {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  /** aria-label для доступности */
  label?: string;
}) {
  return (
    <span
      role="switch"
      aria-checked={checked}
      aria-label={label}
      onClick={() => !disabled && onChange?.(!checked)}
      className={`inline-flex items-center w-[42px] h-6 rounded-full p-0.5 border transition-colors ${
        checked ? "bg-accent border-accent" : "bg-bg-elevated border-border"
      } ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
    >
      <span
        className="w-[18px] h-[18px] rounded-full bg-white transition-transform"
        style={{ transform: checked ? "translateX(18px)" : "translateX(0)" }}
      />
    </span>
  );
}
